import _get from 'lodash/get';
import { showLoader, hideLoader } from '../../actions/shared/loader';
import { showError, setErrorObject } from '../../actions/shared/HTTPError';
import endPoints from '../../modules/ajio-util/endpoints';
import fetcher from '../../modules/ajio-fetch';
import {
  fetchGetJSONReqOpts,
  fetchGetJSONResHandler,
  getErrorStatusCode,
  errorParser,
  getFetcherHeader
} from '../../modules/ajio-fetch/utils';
import { tokenReCreateParser } from '../../modules/ajio-fetch/utils';
import { readCookie, getCookie, eraseCookie } from '../../components/common/Cookie';
import { createAnonymousToken, setToken } from '../../actions/authUser';
import { fetchCartItemsEDDFromClient, fetchCartItemsEDD } from '../../edd/actions/index.js';
import isNode from '../../modules/ajio-util/isNode';
import { userAllowLocationForLocale } from '../../actions/localeBannerApi/localeClientCall';
import { askUserLocation } from '../../modules/ajio-fetch/utils';
import { updateBannerState } from '../../actions/localeBannerApi/localeClientCall';
import { showModal, hideModal, updateModal } from '../../actions/modal';
import { addLocaleInfoToCleverTap } from '../../modules/ajio-util/cleverTap/eventUtils';
import { checkFingerPrintDetails } from '../../utils/fingerPrint';
import { gtmEventPush } from '../../modules/ga/GTMdatalayer';
import luxeScreen from '../../refresh/constants/luxeScreenType';
import properties from '../../modules/ajio-util/properties';

export function setAddress(addresses = {}) {
  return {
    type: 'SET_ADDRESS_DATA',
    addresses
  };
}

function getAddressSuccess() {
  return {
    type: 'GET_ADDRESS_SUCCESS',
    success: true
  };
}

function getAddressFail(error) {
  return {
    type: 'GET_ADDRESS_FAIL',
    success: false
  };
}

function addAddressSuccess() {
  return {
    type: 'ADD_ADDRESS_SUCCESS',
    addAddresssuccess: true
  };
}

function addAddressFail(error) {
  return {
    type: 'ADD_ADDRESS_FAIL',
    addAddresssuccess: false
  };
}

function deleteAddressSuccess(id = '') {
  return {
    type: 'DELETE_ADDRESS_SUCCESS',
    delAddresssuccess: true,
    id
  };
}

function deleteAddressFail(error) {
  return {
    type: 'DELETE_ADDRESS_FAIL',
    delAddresssuccess: false
  };
}

function editAddressSuccess() {
  return {
    type: 'EDIT_ADDRESS_SUCCESS',
    editAddresssuccess: true
  };
}

function editAddressFail(error) {
  return {
    type: 'EDIT_ADDRESS_FAIL',
    editAddresssuccess: false
  };
}

function updateBannerInfo(res) {
  return {
    type: 'BANNER_INFO',
    bannerInfo: res
  };
}

export function setCheckedAddress(
  id,
  postalCode,
  index,
  updateEDD = true,
  isStoreAddress = false,
  callback
) {
  return (dispatch, getState) => {
    if (postalCode && postalCode.length && updateEDD && !isNode()) {
      dispatch(fetchCartItemsEDDFromClient(postalCode)).then(response => {
        const { status: { statusCode: apiResponseStatusCode = 1 } = {} } = response || {};

        if (apiResponseStatusCode === 0) {
          const { pinCode = '', servicability = false } = response || {};
          if (!servicability) {
            window.ga &&
              window.ga('send', {
                hitType: 'event',
                eventCategory: 'buttonTap',
                eventAction: 'EDD on Shipping Page',
                eventLabel: `Proceed to payment disabled - ${pinCode}`
              });
          }
        }
        typeof callback === 'function' && callback();
      }).catch(err => {
        console.error(err);
        typeof callback === 'function' && callback();
      });
    }
    if (isStoreAddress) {
      dispatch({
        type: 'SET_STORE_ADDRESS_ID',
        id,
        postalCode,
        index
      });
    } else {
      dispatch({
        type: 'SET_ADDRESS_ID',
        id,
        postalCode,
        index
      });
    }
  };
}

export function setPostalCode(postalData = {}) {
  return {
    type: 'SET_POSTAL_DATA',
    postalData
  };
}

export function resetPostalCode() {
  return {
    type: 'RESET_POSTAL_DATA'
  };
}

export function setPinCode(postalCode = '') {
  return {
    type: 'SET_POSTAL_CODE',
    postalCode
  };
}
export function setActiveIndex(activeIdx = '') {
  return {
    type: 'SET_ACTIVE_INDEX',
    activeIdx
  };
}
/*
  function to get the address details from API
*/

export function getAddressData(requestObj = {}, cb = null) {
  let { isRequestOrginIsBrowser = false, request = {} } = requestObj;
  const url = properties.getProperty('apiUrl');
  const rilwebserviceUrl = '/rilfnlwebservices/v2/rilfnl';

  return dispatch => {
    let { pathname = '', defaultAddrOnly = false } = request;
    let apiEndPoint;
    /**
     * Show loader if the call is triggered from client-side
     */
    let body = {};
    let userName = '';
    let token = '';
    let headerInfo = {};

    if (isRequestOrginIsBrowser) {
      dispatch(showLoader('address-loader'));
      apiEndPoint = `/api/my-account/getaddress?returnDefault=${defaultAddrOnly}`;
    } else {
      userName = request.cookies.U;
      token = request.cookies.A;
      headerInfo = getFetcherHeader(request);

      const { device: { client_type = '' } = {} } = request;

      apiEndPoint = `${url}${rilwebserviceUrl}/users/${userName}/addresses?fields=FULL&client_type=${client_type}`;
      if (defaultAddrOnly == 'true') {
        apiEndPoint = `${apiEndPoint}&returnDefault=${defaultAddrOnly}`;
      }
    }

    console.log('🚀 ~ getAddressData ~ apiEndPoint:', apiEndPoint);
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts(
        isRequestOrginIsBrowser
          ? {
              body: JSON.stringify(body),
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              credentials: 'include'
            }
          : {
              headers: {
                Authorization: `Bearer ${token}`,
                ...headerInfo
              }
            }
      )
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        console.log('🚀 ~ getAddressData ~ response:', response);
        dispatch(setAddress(response));
        dispatch(getAddressSuccess());
        dispatch(hideLoader('address-loader'));
        if (cb) cb(response);
      })
      .catch(error => {
        console.log('🚀 ~ getAddressData ~ error:', error);
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          console.log('🚀 ~ errorParser ~ errorObj:', errorObj);
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              getAddressData(requestObj)(dispatch);
            });
          }
          dispatch(getAddressFail(error));
          dispatch(setErrorObject(errorObj));
          dispatch(hideLoader('address-loader'));
        });
      });
  };
}

export function addressReturnData(requestObj = {}) {
  let { isRequestOrginIsBrowser = false, request = {} } = requestObj;
  let { conginmentCode = '', selectedAddress = '', addresses = [] } = request;
  if (conginmentCode === '') {
    conginmentCode = _get(request, 'query.consignmentCode', '');
  }
  return dispatch => {
    let { pathname = '' } = request;
    let apiEndPoint;
    /**
     * Show loader if the call is triggered from client-side
     */
    let body = {};
    if (isRequestOrginIsBrowser) {
      let { headers: { host = '' } = {} } = request;
      dispatch(showLoader('address-loader'));
      apiEndPoint = `/api/my-account/address?consignmentCode=${conginmentCode}&addressId=${selectedAddress}`;
    } else {
      let { headers: { host = '' } = {} } = request;
      apiEndPoint = `http://${host}/api/my-account/address?consignmentCode=${conginmentCode}&addressId=${selectedAddress}`;
      body = {
        A: request.cookies.A,
        U: request.cookies.U
      };
    }
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        body: JSON.stringify(body),
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        addresses = addresses.map(address =>
          address.id === selectedAddress
            ? { ...response.addresses[0], defaultAddress: address.defaultAddress }
            : address
        );
        dispatch(setAddress({ ...response, addresses }));
        dispatch(getAddressSuccess());
        dispatch(hideLoader('address-loader'));
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          if (statusCode === 401) {
            tokenReCreateParser(statusCode, errorObj).then(() => {
              addressReturnData(requestObj)(dispatch);
            });
          }
          dispatch(getAddressFail(error));
          dispatch(setErrorObject(errorObj));
          dispatch(hideLoader('address-loader'));
        });
      });
  };
}
export function resetPostalData() {
  return dispatch => {
    dispatch(resetPostalCode());
  };
}

export function deleteAddress(deleteAddressObj) {
  return (dispatch, getState) => {
    // const {  } = getState();
    dispatch(showLoader('address-loader'));
    const { entryNumber = -1 } = deleteAddressObj;

    let apiEndPoint = `/api/my-account/deleteaddress`;

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ entryNumber })
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        let { entryNumber: id = '' } = deleteAddressObj;
        dispatch(deleteAddressSuccess(id));
        dispatch(setAddress(response));

        const userCurrentAddress = readCookie('USER_ADDR');
        const userCurrentAddressObj = (userCurrentAddress && JSON.parse(userCurrentAddress)) || {};
        const { addressId = '' } = userCurrentAddressObj;
        if (addressId == entryNumber) {
          eraseCookie('USER_ADDR');
          eraseCookie('RushAvail'); 
          eraseCookie('RushLocationCoords');

          eraseCookie('PC');
        }
        let messageBar = {
          errorType: 'info',
          message: 'Address Deleted Successfully'
        };
        dispatch(setErrorObject(messageBar));
        dispatch(hideLoader('address-loader'));
        let timeout = setTimeout(() => {
          dispatch(setErrorObject({}));
          clearTimeout(timeout);
        }, 5000);
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              deleteAddress(deleteAddressObj)(dispatch);
            })
            .catch(error => {
              dispatch(deleteAddressFail(error));
              dispatch(setErrorObject(error));
              dispatch(hideLoader('address-loader'));
              let timeout = setTimeout(() => {
                dispatch(setErrorObject({}));
                clearTimeout(timeout);
              }, 5000);
            });
        });
      });
  };
}

export function addAddress(data, cb, closeDialogModal) {
  return function(dispatch) {
    dispatch(showLoader('address-loader'));
    let apiEndPoint = `/api/my-account/new-address-add`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(data),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(setAddress(response));
        dispatch(addAddressSuccess());
        let messageBar = {
          errorType: 'info',
          message: 'Address Added Successfully'
        };
        dispatch(setErrorObject(messageBar));
        dispatch(hideLoader('address-loader'));
        typeof closeDialogModal === 'function' && closeDialogModal();
        let timeout = setTimeout(() => {
          dispatch(setErrorObject({}));
          clearTimeout(timeout);
        }, 5000);
        if (cb) {
          const { addresses = [] } = response;
          cb(addresses);
        }
      })
      .catch(error => {
        const { message = '' } = error;
        gtmEventPush({ event: 'shipping_error', form_type: 'error', error_message: message });
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              addAddress(data)(dispatch);
            })
            .catch(error => {
              dispatch(addAddressFail(error));
              dispatch(setErrorObject(error));
              dispatch(hideLoader('address-loader'));
              let timeout = setTimeout(() => {
                dispatch(setErrorObject({}));
                clearTimeout(timeout);
              }, 5000);
            });
        });
      });
  };
}

export function editAddress(editAddressObj, cb, closeDialogModal) {
  return function(dispatch) {
    dispatch(showLoader('address-loader'));
    let apiEndPoint = `/api/my-account/edit-address`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        body: JSON.stringify(editAddressObj),
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(setAddress(response));
        dispatch(editAddressSuccess());
        let messageBar = {
          errorType: 'info',
          message: 'Address has been Updated'
        };
        dispatch(setErrorObject(messageBar));
        dispatch(hideLoader('address-loader'));
        typeof closeDialogModal === 'function' && closeDialogModal();
        let timeout = setTimeout(() => {
          dispatch(setErrorObject({}));
          clearTimeout(timeout);
        }, 5000);
        if (cb) {
          const { addresses = [] } = response;
          cb(addresses);
          // cb(response);
        }
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              editAddress(editAddressObj)(dispatch);
            })
            .catch(error => {
              dispatch(editAddressFail(error));
              dispatch(setErrorObject(error));
              dispatch(hideLoader('address-loader'));
              let timeout = setTimeout(() => {
                dispatch(setErrorObject({}));
                clearTimeout(timeout);
              }, 5000);
            });
        });
      });
  };
}

function proceedToPaymentCartCheck(cartId) {
  return function(dispatch) {
    let apiEndPoint = `/api/cart/paymentcheck`;

    return new Promise(function(resolve, reject) {
      return fetcher(
        apiEndPoint,
        fetchGetJSONReqOpts({
          credentials: 'include'
        })
      )
        .then(fetchGetJSONResHandler)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          let statusCode = getErrorStatusCode(error);
          errorParser(error, statusCode).then((errorObj = {}) => {
            reject(errorObj);
          });
        });
    });
  };
}

function checkDeliveryable(pincode) {
  let apiEndPoint = `/api/cart/delivery/${pincode}`;
  return new Promise(function(resolve, reject) {
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        let {
          hasFwdService = false,
          msg = "Sorry, we currently don't deliver orders to this pincode."
        } = response;
        if (hasFwdService) {
          resolve();
        } else {
          let messageBar = {
            errorType: 'info',
            message: msg
          };
          reject(messageBar);
        }
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          reject(errorObj);
        });
      });
  });
}

export function proceedToPaymentCheck(params, callback) {
  let {
    addressId: id = '',
    channelType = 'WEB',
    postalCode = '',
    cartId = '',
    isStorePick = false,
    storeData = {},
    showConvenienceFeeFlow = false
  } = params;
  return function(dispatch, getState) {
    if (isStorePick || (id && postalCode)) {
      dispatch(showLoader('address-loader'));
      return new Promise((resolve, reject) => {
        return (
          setDelivery(
            id,
            dispatch,
            isStorePick,
            storeData,
            getState,
            channelType,
            showConvenienceFeeFlow
          )
            // coment this code ===> https://devops.jio.com/Retail/E-Com_DCFL/_workitems/edit/207928/
            // .then(() => dispatch(proceedToPaymentCartCheck(cartId)))
            .then(() => {
              // dispatch(hideLoader("address-loader"));
              callback();
            })
            .catch(error => {
              let { statusCode } = error;
              if (statusCode == 401) {
                tokenReCreateParser(statusCode).then(() => {
                  return proceedToPaymentCheck(params, callback)(dispatch);
                });
              } else {
                dispatch(setErrorObject(error));
                dispatch(hideLoader('address-loader'));
              }
            })
        );
      });
    }
    let messageBar = {
      errorType: 'info',
      message: 'You must provide a delivery address in order to go to the next step.'
    };
    dispatch(setErrorObject(messageBar));
  };
}

export function setDelivery(
  id,
  dispatch,
  isStorePick,
  storeData,
  getState,
  deviceType,
  showConvenienceFeeFlow
) {
  return checkFingerPrintDetails()
    .then(() => {
      const body = {
        baseRequest: {
          consumerType: 'STOREFRONT',
          pageType: 'string',
          tenantId: 'AJIO',
          cartId: getCookie('C'),
          channelInfo: {
            appType: 'OTHER',
            appVersion: 'string',
            channelType: deviceType,
            deviceId: 'string',
            nthOrderOnChannel: 0,
            osType: 'WINDOW',
            osVersion: 'string',
            sessionId: 'string'
          },
          userInfo: {
            email: decodeURIComponent(
              _get(getState(), 'bannerInfo.customerInfo.email', getCookie('U'))
            ),
            phoneNumber: _get(getState(), 'bannerInfo.customerInfo.mobile', getCookie('MN')),
            profileName: _get(getState(), 'bannerInfo.customerInfo.profileName', getCookie('un')),
            userId: decodeURIComponent(
              _get(getState(), 'bannerInfo.customerInfo.uuid', getCookie('CI'))
            )
          }
        }
      };
      let extraParam = {};
      if (id) {
        extraParam = { addressId: id };
      }
      if (isStorePick) extraParam = { pickupNode: storeData.pickupNode };
      return new Promise(function(resolve, reject) {
        let apiEndPoint = `/api/my-account/banner-info`;
        return fetcher(
          apiEndPoint,
          fetchGetJSONReqOpts({
            method: 'POST',
            headers: { 'content-type': 'application/json' },
            credentials: 'include',
            body: JSON.stringify({
              token: getCookie('A'),
              item: body,
              extraParam,
              showConvenienceFeeFlow
            })
          })
        )
          .then(fetchGetJSONResHandler)
          .then(response => {
            dispatch(updateBannerInfo(response));
            resolve(response);
          })
          .catch(error => {
            let statusCode = getErrorStatusCode(error);
            errorParser(error, statusCode).then((errorObj = {}) => {
              dispatch(setErrorObject(errorObj));
            });
          });
      });
    })
    .catch(err => {
      let messageBar = {
        errorType: 'info',
        pageType: 'login-info',
        message: 'oops! something went wrong, please try again...'
      };
      dispatch(setErrorObject(messageBar));
    });
}

export function postalCodeFetch(postalObj = {}, callback, validatePostalCode = false) {
  return (dispatch, getState) => {
    // dispatch(showLoader("address-loader"))
    const { postalCode = -1, pincodeGroup = '' } = postalObj;
    let apiEndPoint = `/api/my-account/checkpostalcode/${postalCode}`;

    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(setPostalCode(response));
        dispatch(hideLoader('address-loader'));
        let { invalidpostalcode = '' } = response;
        // TODO: remove below line
        // invalidpostalcode = true;
        if (typeof callback === 'function') {
          if (validatePostalCode === true) {
            callback({ invalidpostalcode });
          } else if (invalidpostalcode === true) {
            callback();
          } else {
            updateBannerState({ ...response, pincodeGroup })(dispatch, getState);
            addLocaleInfoToCleverTap(response);
          }
        }
      })
      .catch(error => {
        if (typeof callback === 'function') {
          if (validatePostalCode === true) {
            callback({ error });
          } else {
            callback();
          }
        } else {
          let statusCode = getErrorStatusCode(error);
          errorParser(error, statusCode).then((errorObj = {}) => {
            tokenReCreateParser(statusCode, errorObj)
              .then(() => {
                return postalCodeFetch(postalObj)(dispatch);
              })
              .catch(error => {
                dispatch(setErrorObject(error));
                dispatch(hideLoader('address-loader'));
                let timeout = setTimeout(() => {
                  dispatch(setErrorObject({}));
                  clearTimeout(timeout);
                }, 5000);
              });
          });
        }
      });
  };
}

// Pick from store

export function setStoreAddressList(data = {}) {
  return {
    type: 'SET_STORE_ADDRESS_LIST',
    data
  };
}

export function resetStoreAddressData() {
  return {
    type: 'RESET_STORE_ADDRESS_DATA'
  };
}

export function setEligiblePickItems(data = {}) {
  return {
    type: 'SET_ELIGIBLE_PICK_ITEMS',
    data
  };
}

export function storeListFromPincode(
  pincode,
  isStore = false,
  isDefaultFetch = false,
  callback = '',
  luxe = false,
  storeName = ''
) {
  return dispatch => {
    dispatch(showLoader('address-loader'));
    let apiEndPoint = '/api/my-account/storeNodes';
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ pincode, isStore })
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        let eventLabel;
        let no_of_results;
        if (!response.storeNodes) {
          eventLabel = `No store found - ${pincode}`;
          no_of_results = 0;
        } else {
          no_of_results = response.storeNodes.length;
          eventLabel = `${pincode} searched, ${no_of_results} results found`;
        }
        window.ga &&
          window.ga('send', {
            hitType: 'event',
            eventCategory: 'buttonTap',
            eventAction: 'Pick from Store-Shipping',
            eventLabel
          });
        const { shippingStorePickUp: { screenType = '', screenName = '' } = {} } = luxeScreen;
        if (luxe) {
          gtmEventPush({
            event: 'store_search_select',
            event_category: 'checkout interactions',
            event_action: 'find store search select',
            store_type: storeName,
            event_label: storeName,
            page_type: screenType,
            page_name: screenName
          });
          gtmEventPush({
            event: 'store_search_success',
            event_category: 'checkout interactions',
            event_action: 'find store search success',
            store_type: storeName,
            event_label: no_of_results,
            page_type: screenType,
            page_name: screenName
          });
        } else {
          gtmEventPush({
            event: 'find_store_search_select',
            event_category: 'checkout interactions',
            event_action: 'find store search select',
            zipcode: pincode,
            category: 'Shipping',
            no_of_results
          });
          gtmEventPush({
            event: 'find_store_search_success',
            event_category: 'checkout interactions',
            event_action: 'find store search success',
            zipcode: pincode,
            category: 'Shipping',
            no_of_results
          });
        }
        dispatch(setStoreAddressList(response));
        if (isDefaultFetch && response.storeNodes) {
          const { id, postalCode } = response.storeNodes[0].storeAddress;
          dispatch(setCheckedAddress(id, postalCode, 0, true, true));
          dispatch(setStoreAddressList({}));
        }
        dispatch(hideLoader('address-loader'));
        const { status: { statusCode = '' } = {} } = response;
        statusCode === 1 && callback && callback();
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              return storeListFromPincode(pincode)(dispatch);
            })
            .catch(error => {
              dispatch(setErrorObject(error));
              dispatch(hideLoader('address-loader'));
            });
        });
      });
  };
}

export function eligiblePickItems() {
  return dispatch => {
    dispatch(showLoader('address-loader'));
    let apiEndPoint = '/api/my-account/eligiblePickItems';
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: { 'content-type': 'application/json' },
        credentials: 'include'
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        dispatch(setEligiblePickItems(response));
        dispatch(hideLoader('address-loader'));
      })
      .catch(error => {
        let statusCode = getErrorStatusCode(error);
        errorParser(error, statusCode).then((errorObj = {}) => {
          tokenReCreateParser(statusCode, errorObj)
            .then(() => {
              return storeListFromPincode(pincode)(dispatch);
            })
            .catch(error => {
              dispatch(setErrorObject(error));
              dispatch(hideLoader('address-loader'));
            });
        });
      });
  };
}

// Abhishek's Changes

export function setFraudCheckedCODAvailability(isAvailable = false) {
  return {
    type: 'SET_FRAUD_CHECKED_COD_AVAILABILITY',
    isAvailable
  };
}

export function fraudCheckForCOD(params) {
  let {
    addressId: id = '',
    channelType = 'WEB',
    postalCode = '',
    cartId = '',
    isStorePick = false,
    storeData = {}
  } = params;
  return function(dispatch, getState) {
    if (isStorePick || (id && postalCode)) {
      dispatch(showLoader('address-loader'));
      return new Promise((resolve, reject) => {
        return setDelivery(id, dispatch, isStorePick, storeData, getState, channelType)
          .then(() => dispatch(proceedToPaymentCartCheck(params.cartId)))
          .then(response => {
            const {
              cartRequest: { cartId = '' },
              order: { amount: cartAmount = 0 },
              cartChecksum,
              tenantTransactionId
            } = response;
            const fraudCheckForCODParams = {
              cartId,
              cartAmount,
              cartChecksum,
              tenantTransactionId,
              inventoryCheckEnable: true
            };
            let apiEndPoint = '/api/shipping/fraudCheck';
            return fetcher(
              apiEndPoint,
              fetchGetJSONReqOpts({
                method: 'POST',
                body: JSON.stringify(fraudCheckForCODParams),
                headers: { 'content-type': 'application/json' },
                credentials: 'include'
              })
            )
              .then(fetchGetJSONResHandler)
              .then(response => {
                dispatch(
                  setEligiblePickItems(response.isCartAndUserValidForCOD && params.codEligible)
                );
                dispatch(hideLoader('address-loader'));
              });
          })
          .catch(error => {
            let { statusCode } = error;
            if (statusCode == 401) {
              tokenReCreateParser(statusCode).then(() => {
                return fraudCheckForCOD(params)(dispatch);
              });
            } else {
              dispatch(setErrorObject(error));
              dispatch(hideLoader('address-loader'));
            }
          });
      });
    }
    let messageBar = {
      errorType: 'info',
      message: 'You must provide a delivery address in order to go to the next step.'
    };
    dispatch(setErrorObject(messageBar));
  };
}
